import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";

const CloseIconButton = ({ onClose }) => {
  return (
    <Box display="flex" alignItems="flex-end" justifyContent={"end"}>
      <CloseIcon onClick={onClose} sx={{ cursor: "pointer" }} />
    </Box>
  );
};

CloseIconButton.propTypes = {
  onClose: PropTypes.func,
};

export default CloseIconButton;
